import { UserApi, type User } from "certiblok-api-manager";
import React, { useContext, useEffect } from "react";
import { useApi, useFetch } from "./api";
import { useLocation } from "react-router-dom";
import { useAbility } from "./useAbilityRules";
import { useGenerateNewAbilities } from "./useGenerateNewAbilities";

export const UserContext = React.createContext<{ user?: User; reload: () => void; loading: boolean }>({} as any);

export function useMe() {
	const { user, reload, loading } = useContext(UserContext);

	return { me: user, reload, loading };
}

export function UserContextProvider({ children }: { children: React.ReactNode }) {
	const userApi = useApi(UserApi);
	const { ability } = useAbility();

	const currentLocation = useLocation();
	const isInSSOLogin = currentLocation.pathname.includes("sso");

	const isAuthenticated = ability.can("readAll", "User");

	const { data: me, revalidate, loading } = useFetch(userApi.getMe, { skip: !isAuthenticated || isInSSOLogin });
	const generateNewAbilities = useGenerateNewAbilities();

	useEffect(() => {
		if (me) {
			generateNewAbilities();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <UserContext.Provider value={{ user: me, reload: revalidate, loading }}>{children}</UserContext.Provider>;
}
